module.exports = __webpack_public_path__ + "2d0afd50cdd1b5212d1efec33459517e.svg";